
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import { pull, remove } from "lodash";
import CustomsPackingInfoInTable from "@/views/components/CustomsPackingInfoInTable.vue";
import {
  CustomsPackingModel,
  PackingVolume,
  PackingWeight, ProblemType,
  ProductInfoModel, SecondaryPackingModel,
  State
} from "@/model/HenganLoadingPlanModels";
import {CustomsPackingCode} from "@/model/HqPackingListModels";
import {findSourceMap} from "module";
import { Message } from "element-ui";
import { confirmStockUp } from "@/api/hengan-loading-plan";
import { deepClone } from "@/utils/deepClone";

/**
 * 备货确认
 */
@Component({
  name: "ConfirmStockUpComponent",
  components: { CustomsPackingInfoInTable },
  methods: {
    pull, remove
  }
})

export default class extends Vue {

  @Prop({ required: true }) private data: HenganLoadingPlanPackingInfoResponse;
  @Prop({required: true}) private henganLoadingPlanId: string;
  private isAllSelect = false;
  private result: CustomsPackingResponse[] = [];
  private selectedCustomsPackingIds: string[] = [];

  @Watch("data",{deep: false,immediate: true})
  private convert() {
    this.result = [];
    let customsPackingResponses = this.convertCustomsPackingInfoData(this.data.customsPackingSet);
    this.group(customsPackingResponses).map(value => {
      if(value[0].groupId != null){
        this.result.push(this.creatFatherCustomsPackingInfoData(value));
      }else {
        value.map((val) =>{
          this.result.push(val);
        })
      }
    })
  }

  private convertCustomsPackingInfoData(customsPackingInfo: CustomsPackingModel[]){
    return customsPackingInfo.map(value => {
      let customsPackingResponse = new CustomsPackingResponse();
      customsPackingResponse.id = value.id;
      customsPackingResponse.code = value.code;
      customsPackingResponse.packingVolume = value.packingVolume;
      customsPackingResponse.packingWeight = value.packingWeight;
      customsPackingResponse.state = value.state;
      customsPackingResponse.problemType = value.problemType;
      customsPackingResponse.secondaryPackingSet = value.secondaryPackingSet;
      customsPackingResponse.groupId = value.groupId;
      customsPackingResponse.cartonNumber = value.cartonNumber;
      customsPackingResponse.descriptions = value.descriptions;
      customsPackingResponse.inventory = value.inventory;
      customsPackingResponse.useInventoryQuantity = value.useInventoryQuantity;
      return customsPackingResponse;
    })
  }

  private creatFatherCustomsPackingInfoData(childrenCustomsPackingInfo: CustomsPackingResponse[]) {
    const customsPackingResponse = childrenCustomsPackingInfo[0];
    customsPackingResponse.code.serialNumber = childrenCustomsPackingInfo[0].code.serialNumber + "\n+" + (childrenCustomsPackingInfo.length - 1) + "箱";
    childrenCustomsPackingInfo.splice(0,1);
    customsPackingResponse.children = childrenCustomsPackingInfo;
    return customsPackingResponse;
  }

  private group = (sortData: CustomsPackingResponse[]) => {
    const groupBy = (array: CustomsPackingResponse[], f: Function) => {
      const groups: {
        [key: string]: CustomsPackingResponse[],
      } = {};
      array.forEach((item) => {
        const group = JSON.stringify(f(item));
        groups[group] = groups[group] || [];
        groups[group].push(item);
      });
      return Object.keys(groups).map((group) => {
        return groups[group];
      });
    };
    const sorted = groupBy(sortData, (item: CustomsPackingResponse) => {
      return item.groupId;
    });
    return sorted;
  };

  private handleSelectAll(rows, first) {
    if (!first) {
      this.isAllSelect = !this.isAllSelect;
    }
    rows.map(el => {
      if (el.children) {
        el.children.map(j => {
          this.toggleSelection(j, this.isAllSelect);
        });
        if (el.children.length > 0) {
          this.handleSelectAll(el.children, true);
        }
        if (el.children == 0) {
          this.toggleSelection(el, this.isAllSelect);
        }
      }
    });
  }

  private async onBatchConfirmStockUp() {
    if (this.selectedCustomsPackingIds.length < 1) {
      Message.error({
        message: "请选择主包装",
        duration: 2000
      });
      return;
    }
    this.$confirm('此次操作将批量确认所有已选的主包装', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      confirmStockUp(this.henganLoadingPlanId, this.selectedCustomsPackingIds).then(() => this.$emit("changeList"));
      // this.$emit("changeList");
    })
  }

  private handleSelectChange(rows) {
    this.selectedCustomsPackingIds = rows.map(r => r.id);
  }

  private toggleSelection(row, select) {
    const dis = this.$refs.districtTable as any;
    if (select) {
      dis.toggleRowSelection(row, select);
    } else {
      dis.clearSelection();
    }
  }

}

export class HenganLoadingPlanPackingInfoResponse {
  id: string;
  code: string;
  parentCode: string;
  factoryName: string;
  customsPackingSet: CustomsPackingModel[] = [];
  unpackedProductInfos: ProductInfoModel[] = [];
}

export class CustomsPackingResponse {
  id: string;
  code: CustomsPackingCode;
  packingVolume: PackingVolume;
  packingWeight: PackingWeight;
  state: State;
  ackType: string;
  problemType: ProblemType;
  secondaryPackingSet: SecondaryPackingModel[] = [];
  groupId: string;
  children: CustomsPackingResponse[] = [];
  cartonNumber: number;
  descriptions: string[];
  inventory: string;
  useInventoryQuantity: number;
}

